/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-concat */
import React, {PureComponent} from 'react'
import {Tooltip} from 'antd'
import Utils from '../Utils/utils'

import AdLibrary from './img/AdLibrary'
import Following from './img/Following'
import Watchlist from './img/Watchlist'
import TopPerformingAds from './img/TopPerformingAds'
import InterestExplorer from './img/InterestExplorer'
import Calculators from './img/Calculators'
import Other from './img/Other'
import SuggestAFeature from './img/SuggestAFeature'
import Help from './img/Help'
import Settings from './img/Settings'
import ProfileAccount from './img/ProfileAccount'
import ProfileHelp from './img/ProfileHelp'
import MailLink from './img/MailLink'
import Clock from './img/Clock'
import Lock from './img/Lock'
import Filter from './img/Filter'
import ArrowSidebarFilter from './img/ArrowSidebarFilter'
import Copy from './img/Copy'
import FollowingUser from './img/FollowingUser'
import Search from './img/Search'
import ExportFile from './img/ExportFile'

import HelpSmall from './img/HelpSmall'
import Facebook from './img/Facebook'
import Instagram from './img/Instagram'
import Video from './img/Video'
import Photo from './img/Photo'
import Carousel from './img/Carousel'
import ArrowLink from './img/ArrowLink'
import GlobalLink from './img/GlobalLink'
import DetailsLink from './img/DetailsLink'
import ArrowSliderNext from './img/ArrowSliderNext'
import Checked from './img/Checked'
import Edit from './img/Edit'
import Delete from './img/Delete'
import Cancel from './img/Cancel'
import Attention from './img/Attention'
import DeleteTag from './img/DeleteTag'
import NoData from './img/CloudClose'
import Undo from './img/Undo'
import Flag from './img/Flag'
import ResultOk from './img/ResultOk'
import FollowingTab from './img/FollowingTab'
import ScheduledTab from './img/ScheduledTab'
import PreparedTab from './img/PreparedTab'
import SavedTab from './img/SavedTab'
import EmptyChartViews from './img/EmptyChartViews'
import EmptyChartLikes from './img/EmptyChartLikes'
import EmptyChartComments from './img/EmptyChartComments'
import EmptyChartShares from './img/EmptyChartShares'
import EmptyChartStatus from './img/EmptyChartStatus'
import EmptyChartTargeting from './img/EmptyChartTargeting'
import EmptyScreenshot from './img/EmptyScreenshot'
import EmptyFolder from './img/EmptyFolder'
import EmptyFollowing from './img/EmptyFollowing'
import EmptyPublication from './img/EmptyPublication'
import EmptyScheduled from './img/EmptyScheduled'
import EmptyPrepared from './img/EmptyPrepared'
import EmptyCompanyInfo from './img/EmptyCompanyInfo'

import PaginationFirst from './img/PaginationFirst'
import PaginationPrev from './img/PaginationPrev'
import PaginationNext from './img/PaginationNext'
import PaginationLast from './img/PaginationLast'

/*sortBy*/
import MostRecent from './img/MostRecent'
import Oldest from './img/Oldest'
import Likes from './img/Likes'
import Comments from './img/Comments'
import Shares from './img/Shares'
import Views from './img/Views'
import LongestRunning from './img/LongestRunning'
import Reactions from './img/Reactions'
import ReactionsDark from './img/ReactionsDark'
import Love from './img/Love'
import Care from './img/Care'
import Haha from './img/Haha'
import Wow from './img/Wow'
import Sad from './img/Sad'
import Angry from './img/Angry'

import Created from './img/Created'
import Eye from './img/Eye'
import EyeInvisible from './img/EyeInvisible'

import ProfileLogout from './img/ProfileLogout'
import Close from './img/Close'

import CloseMenu from './img/CloseMenu'
import OpenMenu from './img/OpenMenu'

import Templates from './img/Templates'
//import CloudClose from './img/CloudClose'
import AddUser from './img/AddUser'
import Star from './img/Star'
import Dots from './img/Dots'
import Reset from './img/Reset'
import ArrowCreateLink from './img/ArrowCreateLink'
import MoreDelete from './img/MoreDelete'
import MoreEdit from './img/MoreEdit'
import MoreSchedule from './img/MoreSchedule'

import CloudUpload from './img/CloudUpload'
import Verified from './img/Verified'
import VerifiedV2 from './img/VerifiedV2'
import AttentionReport from './img/AttentionReport'
import Billing from './img/Billing'
import Plan from './img/Plan'
import Notification from './img/Notification'
import ArrowUpgrade from './img/ArrowUpgrade'
import DownloadIcon from './img/DownloadIcon'
import EditCircle from './img/EditCircle'
import AccessTrue from './img/AccessTrue'
import AccessFalse from './img/AccessFalse'
import FilterSelect from './img/FilterSelect'
import LockPayment from './img/LockPayment'
import CloseModal from './img/CloseModal'
import Plus from './img/Plus'
import Replace from './img/Replace'
import DownloadBtn from './img/DownloadBtn'
import Card from './img/Card'
import ProfileSettings from './img/ProfileSettings'
import Report from './img/Report'
import Dashboard from './img/Dashboard'
import Customers from './img/Customers'
import Status from './img/Status'
import ResendEmailLoader from './img/ResendEmailLoader'
import TableSortDescend from './img/TableSortDescend'
import TableSortDescendActive from './img/TableSortDescendActive'
import TableSortAscend from './img/TableSortAscend'
import TableSortAscendActive from './img/TableSortAscendActive'

import UpgradeArrow from './img/UpgradeArrow'
import DowngradeArrow from './img/DowngradeArrow'
import ArrowContinue from './img/ArrowContinue'
import Warning from './img/Warning'
import CheckMark from './img/CheckMark'
import AttentionOutline from './img/AttentionOutline'

import EmptyBillings from './img/EmptyBillings'

import ArrowRight from './img/ArrowRight'
import DeleteBasket from './img/DeleteBasket'
import FaceBookLink from './img/FaceBookLink'
import CheckboxCircle from './img/CheckboxCircle'
import SharesBold from './img/SharesBold'
import MessageBold from './img/MessageBold'
import PlayBold from './img/PlayBold'
import Refresh from './img/Refresh'
import DoubleArrowRight from './img/DoubleArrowRight'
import EmptyLoader from './img/EmptyLoader'
import DownOutlined from './img/DownOutlined'
import UpOutlined from './img/UpOutlined'
import RightOutlined from './img/RightOutlined'
import Like from './img/Like'
import Slash from './img/Slash'
import CheckedSquare from './img/CheckedSquare'
import CloseIcon from './img/CloseIcon'
import DeleteTrash from './img/DeleteTrash'
import Calendar from './img/Calendar'
import UpOutlinedArrow from './img/UpOutlinedArrow'
import NotSavedPost from './img/NotSavedPost'
import SavedPost from './img/SavedPost'
import StarEmpty from './img/StarEmpty'
import AttentionLarge from './img/AttentionLarge'

const __TYPES__ = {
  AdLibrary,
  Following,
  Watchlist,
  TopPerformingAds,
  InterestExplorer,
  Calculators,
  Other,
  SuggestAFeature,
  Help,
  Settings,
  Facebook,
  Instagram,
  Video,
  Photo,
  Carousel,
  ArrowLink,
  GlobalLink,
  DetailsLink,
  ArrowSliderNext,
  AttentionReport,

  MostRecent,
  Oldest,
  Likes,
  Comments,
  Shares,
  Views,
  LongestRunning,
  Reactions,
  ReactionsDark,
  Love,
  Care,
  Haha,
  Wow,
  Sad,
  Angry,
  Created,
  Delete,
  Edit,
  Eye,
  EyeInvisible,
  DeleteTag,
  NoData,
  Undo,
  Flag,
  ResultOk,
  FollowingTab,
  PreparedTab,
  ScheduledTab,
  SavedTab,
  EmptyChartViews,
  EmptyChartLikes,
  EmptyChartComments,
  EmptyChartShares,
  EmptyChartStatus,
  EmptyChartTargeting,
  EmptyScreenshot,
  EmptyFolder,
  EmptyFollowing,
  EmptyPublication,
  EmptyScheduled,
  EmptyPrepared,
  EmptyCompanyInfo,

  HelpSmall,
  AddUser,
  Star,
  ProfileAccount,
  ProfileHelp,
  ProfileLogout,
  MailLink,
  Clock,
  Lock,
  Filter,
  FilterSelect,
  ArrowSidebarFilter,
  Copy,
  FollowingUser,
  Search,
  ExportFile,

  PaginationFirst,
  PaginationPrev,
  PaginationNext,
  PaginationLast,

  CloseMenu,
  OpenMenu,
  Checked,
  Cancel,
  Attention,
  Close,
  Templates,
  Dots,
  Reset,
  ArrowCreateLink,
  CloudUpload,
  Verified,
  VerifiedV2,
  MoreDelete,
  MoreEdit,
  MoreSchedule,
  Billing,
  Plan,
  Notification,
  ArrowUpgrade,
  DownloadIcon,
  EditCircle,
  AccessTrue,
  AccessFalse,
  LockPayment,
  CloseModal,
  Plus,
  Replace,
  DownloadBtn,
  Card,
  ProfileSettings,
  Report,
  Dashboard,
  Customers,
  Status,
  ResendEmailLoader,

  TableSortDescendActive,
  TableSortDescend,
  TableSortAscendActive,
  TableSortAscend,

  UpgradeArrow,
  DowngradeArrow,
  EmptyBillings,

  ArrowRight,

  ArrowContinue,
  Warning,
  CheckMark,
  AttentionOutline,

  DeleteBasket,
  FaceBookLink,
  CheckboxCircle,

  SharesBold,
  MessageBold,
  PlayBold,

  Refresh,
  DoubleArrowRight,

  EmptyLoader,

  DownOutlined,
  UpOutlined,
  RightOutlined,
  Like,
  Slash,
  CheckedSquare,
  CloseIcon,
  DeleteTrash,
  Calendar,
  UpOutlinedArrow,

  NotSavedPost,
  SavedPost,
  StarEmpty,
  AttentionLarge,
}

class Icon extends PureComponent {
  constructor(props, context) {
    super(props, context)
    this.state = {
      btnClass: '',
    }
  }

  render() {
    const {type} = this.props
    const IconComp = __TYPES__[Utils.toPascalCase(type)]
    let {id, onClick, color, opacity, role, btnType, titleText, className, href, width, height, style, tooltipProps} = this.props

    if (role === 'button') {
      if (!btnType) btnType = ''

      return (
        <Tooltip placement='right' title={titleText} {...tooltipProps}>
          <a id={id} onClick={onClick} className={'icon-btn' + ' ' + btnType} style={style}>
            <i>{IconComp ? <IconComp opacity={opacity} color={color} width={width} height={height} style={style} /> : ''}</i>
          </a>
        </Tooltip>
      )
    } else if (role === 'icon') {
      return (
        <IconComp
          className={className}
          style={style}
          onClick={onClick}
          opacity={opacity}
          color={color}
          type={type}
          width={width}
          height={height}
        />
      )
    } else {
      return (
        <a
          id={id}
          href={href}
          target='_blank'
          rel='noopener noreferrer'
          className={className}
          onClick={onClick}
          style={{
            display: 'flex',
            alignItems: 'center',
            ...style,
          }}
          onMouseEnter={() => this.setState({btnClass: 'hover-btn'})}
          onMouseLeave={() => this.setState({btnClass: ''})}
        >
          {IconComp ? (
            <IconComp
              className={this.state.btnClass}
              onClick={onClick}
              opacity={opacity}
              color={color}
              width={width}
              height={height}
              type={type}
            />
          ) : (
            ''
          )}
        </a>
      )
    }
  }
}

export default Icon
